<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.subscription' : 'misc.edition.subscription') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="subscriptionForm" *ngIf="subscriptionForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="name">{{'attribute.name' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="subscriptionForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-3">
        <div class="form-field col-12">
          <label for="description">{{'attribute.description' | transloco}}</label>
        </div>
        <div class="col-12">
          <input pInputText id="description" type="text" formControlName="description" class="w-full">
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-12 xl:col-2">
        <div class="form-field col-12">
          <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.tenant' | transloco"
            [options]="tenants"
            [filter]="true"
            (onChange)="tenantChanged()"
            styleClass="w-full"
            id="tenant"
            optionLabel="name"
            formControlName="tenant"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-2">
        <div class="form-field col-12">
          <label for="organization">{{'model.organization' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.organization' | transloco"
            [options]="organizations"
            [filter]="true"
            [showClear]="true"
            styleClass="w-full"
            id="organization"
            optionLabel="name"
            formControlName="organization"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 lg:col-6 xl:col-2">
        <div class="form-field col-12">
          <label for="active-button">{{'attribute.state' | transloco}}</label><br>
        </div>
        <div class="col-12">
          <p-selectButton id="active-button" formControlName="active" [options]="activeOptions" optionLabel="label" optionValue="value">
            <ng-template let-item pTemplate>
              {{ item.label | transloco }}
            </ng-template>
          </p-selectButton>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6">
        <div class="form-field col-12">
          <label for="subscriptionType">{{'attribute.subscriptionType' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.subscriptionType' | transloco"
            [options]="subscriptionTypes"
            (onChange)="subscriptionTypeChanged($event)"
            styleClass="w-full"
            id="subscriptionType"
            optionLabel="name"
            formControlName="subscriptionType"
          ></p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-12 lg:col-6">
        <div class="form-field col-12">
          <label for="protocol">{{'attribute.protocol' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [placeholder]="'select.protocol' | transloco"
            [options]="protocols"
            (onChange)="protocolChanged($event)"
            styleClass="w-full"
            id="protocol"
            optionLabel="name"
            formControlName="protocol"
          ></p-dropdown>
        </div>
      </div>

      <div class="xl:col-6 col-12">
        <div class="form-field col-12 flex align-items-center">
          <label>{{'attribute.appliedTo' | transloco}} (*)</label>
          <i
            (click)="appliedToInfoVisible = !appliedToInfoVisible"
            class="pi pi-info-circle cursor-pointer ml-2"
            style="font-size: 14px;"
          ></i>
        </div>
        <div class="col-12">
          <div *ngIf="appliedToInfoVisible then appliedToInfo"></div>
          <json-editor
            #appliedToEditor
            [options]="jsonEditorService.buildFormEditorOptions()"
            formControlName="appliedTo"
          ></json-editor>
        </div>
      </div>

      <div class="xl:col-6 col-12">
        <div class="form-field col-12">
          <label>{{'attribute.protocolConfig' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <json-editor
            #protocolConfigEditor
            [options]="jsonEditorService.buildFormEditorOptions()"
            formControlName="protocolConfig"
          ></json-editor>
        </div>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button pButton label="{{'common.cancel' | transloco}}" iconPos="right" class="p-button-danger" [routerLink]="'/subscriptions'"></button>
      <p-button
        *ngIf="subscriptionForm"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        [disabled]="!subscriptionForm.valid"
        (onClick)="persistSubscriptionData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>

<ng-template #appliedToInfo>
  <div class="border-1 border-round border-gray-300 mb-3 fadein animation-duration-200">
    <p class="px-3 pt-3 text-justify">{{'info.subscriptions.summary' | transloco}}</p>
    <p class="px-3 text-justify">{{'info.subscriptions.firstExample' | transloco}}</p>
    <pre class="bg-gray-50"><code>
    "measurementTypes": [
      "meterIndex"
    ]
    </code></pre>
    <p></p>
    <p class="px-3 text-justify">{{'info.subscriptions.secondExample' | transloco}}</p>
    <pre class="bg-gray-50"><code>
    "eventNames": [
      "^sound.*"
    ]
    </code></pre>
  </div>
</ng-template>
